import React from 'react';

/**
 * GenderIcon — einheitliches, kombiniertes Geschlechts-Symbol (Venus + Mars)
 * im Outline-Stil. Laut Issue #9 zentrales Gender-Icon; im Einsatz i.d.R. in
 * Vereinsgrün eingefärbt (via className text-primary-600 o.ä.).
 */
const GenderIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    {/* zentraler Kreis */}
    <circle cx="10.5" cy="13.5" r="4.5" />
    {/* Mars-Pfeil nach oben rechts */}
    <path d="M13.7 10.3 19 5" />
    <path d="M15 5h4v4" />
    {/* Venus-Kreuz nach unten */}
    <path d="M10.5 18v4" />
    <path d="M8.5 20h4" />
  </svg>
);

export default GenderIcon;
